<template>

  <v-container fluid class="px-0 route-info-detailed-status">

    <!-- Route Tracking History -->
    <route-tracking-history class="pt-4 pb-9 page-content" :route="route" />

  </v-container>

</template>

<script>
import RouteTrackingHistory from '@/components/routes/RouteTrackingHistory'

export default {
  name: 'RouteInfoDetailedStatus',

  components: {
    RouteTrackingHistory
  },

  props: {
    routeId: {
      type: String,
      default: null
    }
  },

  data () {
    return {
    }
  },

  computed: {
    route () {
      return this.$parent.route
    }
  }
}
</script>

<style>
</style>
